export default "/form/@formId/embed";
